<header class="auth-header">

  <div class="container">
    <a href="https://clooper.com" target="_blank">
  <app-logo class="logo" secondary></app-logo>
  <app-icon class="icon" secondary></app-icon>
</a>
    <div class="action" *ngIf="showActions">
      <p class="label">{{label}}</p>

      <button
        type="button"
        class="btn btn-dark"
        [attr.data-test]="actionText + '-btn'"
        (click)="onActionClick()"
      >
        {{actionText}}
      </button>

    </div>
  </div>


</header>
